import React, { useEffect, useState } from "react";
import { Thumbnail } from "@culturehq/components";

const LinkedinPostCreator = ({ linkedinShare }) => {
  const [creator, setCreator] = useState({
    name: linkedinShare.creator.name,
    photo: linkedinShare.creator.avatar.thumbUrl,
    title: linkedinShare.creator.title
  });

  useEffect(
    () => {
      if (linkedinShare.socialCompany) {
        setCreator({
          name: linkedinShare.socialCompany.name,
          photo: linkedinShare.socialCompany.logo,
          title: `Published by ${linkedinShare.creator.name}`
        });
      }
    },
    [linkedinShare]
  );

  return (
    <div className="Linkedin_Creator">
      <Thumbnail className="Thumbnail" image={creator.photo} title={creator.name} />
      <div className="Linkedin_Creator--Information">
        <span className="Linkedin_Creator--Information_Creator">{creator.name}</span>
        <span className="Linkedin_Creator--Information_Title">{creator.title}</span>
      </div>
    </div>
  );
};

export default LinkedinPostCreator;
